export interface ProductsWebEntity {
    id: string;
    name: string;
    productId: string;
    productTemplate: string;
  }
  